
const homepage = {
  // Hero section
  'hero.headline': 'Elite Trading. Now Accessible to Everyone.',
  'hero.subheadline': 'Professional investment strategies once reserved for institutions — now available to retail investors through The Club',
  'hero.cta.join': 'Join The Club',
  'hero.cta.track': 'Track Our Performance',
  
  // What is The Club section
  'whatIs.header': 'What is The Club?',
  'whatIs.subtitle': 'Professional Trading, Redefined for You',
  'whatIs.copy': 'At The Club, we\'re reshaping the financial landscape. Our mission is simple: make elite, institutional-level trading strategies accessible to retail investors — with transparency, performance, and trust at the core. Offer a sustainable, long-term business model that allows ordinary people to participate in what was once an exclusive financial world. We\'re here to democratize access to financial freedom — one investor at a time.',
  'whatIs.cta': 'Meet The Club Team',
  
  // Why Join section
  'whyJoin.header': 'Why Join The Club?',
  'whyJoin.subtitle': 'Smart, Simple, Powerful Investing',
  'whyJoin.copy': 'Our platform empowers you to grow your wealth with confidence, guided by top-tier experts who manage your portfolio.',
  'whyJoin.feature1.title': 'Start with just $500',
  'whyJoin.feature1.desc': 'No barriers, no ceiling — scale on your terms',
  'whyJoin.feature2.title': 'Transparent Performance',
  'whyJoin.feature2.desc': 'Real-time access to your portfolio metrics',
  'whyJoin.feature3.title': 'Pro Risk Management',
  'whyJoin.feature3.desc': 'Strategies to protect and grow your capital',
  'whyJoin.feature4.title': 'Global Support',
  'whyJoin.feature4.desc': 'Our team is here — in your language, in your region',
  'whyJoin.cta': 'Invest Now',
  
  // Trusted Broker section
  'broker.header': 'Trusted Broker',
  'broker.subtitle': 'Your Capital Deserves a Safe Home',
  'broker.copy': 'Security and transparency matter. That\'s why we work exclusively with Radex Markets, a regulated broker licensed by the Seychelles Financial Services Authority (FSA). Radex prioritizes client protection by implementing robust security protocols to safeguard both client funds and personal data. It offers cutting-edge technology and a competitive trading environment designed to meet the needs of modern traders.',
  'broker.cta': 'Learn More About Our Broker',
  'broker.badge1': 'Secure Processing',
  'broker.badge2': 'FSA Regulated',
  'broker.badge3': 'Fund Security',
  'broker.badge4': 'Transparent Operations',
  
  // Meet Traders section
  'traders.header': 'Meet Our Traders',
  'traders.subtitle': 'Real Expertise. Proven Strategies.',
  'traders.copy': 'Our trading team brings over 16 years of experience developing institutional algorithmic strategies since 2009. With a deep understanding of global markets, they know how to adapt and perform — no matter the conditions. Some of our professionals have even ranked in the top 5 in the UK on platforms like Pelican Asset Management. With a relentless focus on low drawdowns and strict risk control, they\'re now accessible to you to deliver results.',
  'traders.stats.experience': '16+',
  'traders.stats.experienceLabel': 'Years Experience',
  'traders.stats.rank': 'Top 5',
  'traders.stats.rankLabel': 'UK Trading Ranking',
  'traders.stats.since': 'Since 2009',
  'traders.stats.sinceLabel': 'Strategy Development',
  'traders.approach.algorithmic.title': 'Algorithmic Approach',
  'traders.approach.algorithmic.point1': 'Data-driven decision making',
  'traders.approach.algorithmic.point2': 'Backtested strategies since 2009',
  'traders.approach.algorithmic.point3': 'Risk management parameters',
  'traders.approach.risk.title': 'Risk Control',
  'traders.approach.risk.point1': 'Focus on low drawdowns',
  'traders.approach.risk.point2': 'Strict position sizing rules',
  'traders.approach.risk.point3': 'Adaptive market approach',
  
  // Performance section
  'performance.header': 'The Club Performance',
  'performance.subtitle': 'See Our Traders in Action',
  'performance.recentPerformance': 'Recent Performance',
  'performance.monthlyPerformance': 'Monthly Performance',
  'performance.yearlyPerformance': 'Yearly Projection',
  'performance.maxDrawdown': 'Max Drawdown',
  'performance.winRate': 'Win Rate',
  'performance.cta': 'Track Institutional Strategy in FX Blue',
  'performance.tagline': 'Peak Performance. Minimal Drawdown. 100% Transparency.',
  'performance.myfxbooktext': 'Performance like no other, validated through FX Blue',
  'performance.institutional': 'Institutional Strategy',
  'performance.spartanAi': 'Spartan AI',
  'performance.ctaSpartan': 'Track Spartan AI in Myfxbook',
  'performance.myfxbookTextSpartan': 'Performance like no other, validated through Myfxbook',
  'performance.recentPerformanceInstitutional': 'Institutional Strategy Performance',
  'performance.recentPerformanceSpartan': 'Spartan AI Performance',
  'performance.strategiesCta': 'Learn More About Our Strategies',
  
  // How it works section
  'howItWorks.header': 'How It Works',
  'howItWorks.subtitle': 'Simple Rules. Clear Rewards.',
  'howItWorks.feature1.title': 'Join with just $500',
  'howItWorks.feature1.desc': 'Start small, scale anytime — no maximum limits',
  'howItWorks.feature2.title': 'No Membership Fee',
  'howItWorks.feature2.desc': 'For a limited time, the 20% fee is gone. Invest with TheClub and start earning from day one',
  'howItWorks.feature3.title': 'Aligned Incentives',
  'howItWorks.feature3.desc': 'A 50% performance fee — we only win when you win',
  'howItWorks.feature4.title': 'Withdraw anytime',
  'howItWorks.feature4.desc': 'Full access to capital and profits — no lock-up periods',
  'howItWorks.feature5.title': 'Deposit & Withdrawal Methods',
  'howItWorks.feature5.desc': 'Visa, Mastercard, bank transfer, and crypto – fast and flexible',
  'howItWorks.feature6.title': 'KYC & AML Compliance',
  'howItWorks.feature6.desc': 'Your security and regulatory trust are our priorities',
  'howItWorks.cta': 'Join The Club',
  'howItWorks.calculator.title': 'See Your Growth Potential With Compound Interest',
  'howItWorks.calculator.results': 'Results:',
  'howItWorks.calculator.totalInvestment': 'Total Investment ($)',
  'howItWorks.calculator.investment': 'Investment ($)',
  'howItWorks.calculator.membership': 'Membership Fee ($)',
  'howItWorks.calculator.monthlyRate': 'Monthly Interest Rate (%)',
  'howItWorks.calculator.fiftymonthlyRate': '50% Monthly Interest Rate (%)',
  'howItWorks.calculator.variationRate': 'Monthly Variation Rate (%)',
  'howItWorks.calculator.years': 'Investment Time (Years)',
  'howItWorks.calculator.calculate': 'Calculate',
  'howItWorks.calculator.simpleInvestment': 'Future value with monthly withdrawal',
  'howItWorks.calculator.compoundInvestment': 'Future value with compound',
  'howItWorks.calculator.difference': 'Difference',
  'howItWorks.calculator.monthAbbr': 'M',
  'howItWorks.calculator.yearAbbr': 'Y',
  'howItWorks.calculator.month': 'Month',
  'howItWorks.calculator.year': 'Year',
  
  // Team section
  'team.header': 'Meet Our Team',
  'team.subtitle': 'The Club is Driven by Visionaries',
  'team.text': 'Meet the minds shaping The Club\'s mission and fostering global financial freedom through transparency, integrity, and high performance — making investing accessible to all.',
  'team.member1': 'Gianluca N. – Head of New Markets \nDevelopment',
  'team.member2': 'Samuel N. – Head of Marketing',
  'team.member3': 'Marco M. – Brokerage Consultant\n(Head of Italy\nat Radex Markets)',
  'team.member4': 'Lloyd S. – Chief Trading Officer',
  'team.member5': 'Horacio A. – Executive \nTechnology Consultant',
  
  // Global Presence section
  'global.header': 'Global Presence',
  'global.subtitle': 'Local Faces. Global Reach.',
  'global.text': 'Whether you\'re in Italy, Germany, the Middle East, or Latin America, we\'re here with local support — in your language and in your time zone.',
  'global.contact1': 'Germano M. – Italian Speaking Representative',
  'global.contact2': 'Manuel G. – German Speaking Representative',
  'global.contact3': 'Horacio A. – Spanish Speaking Representative',
  'global.contact4': 'Aisha R. – English Speaking Representative',
  'global.contact5': 'XXX XXXX – French & Arabic Speaking Representative',
  'global.tagline': 'Want to grow your own community with The Club? Speak directly with one of our representatives.',
  
  // Referral section
  'referral.header': 'Referral Program',
  'referral.subtitle': 'Earn While Growing Your Community',
  'referral.text': 'Share the Opportunity. Build Your Income.',
  'referral.copy.default': 'As a partner of The Club, you can not only earn from your investments but also help others grow their income. Our 10-level compensation plan enables you to build long-term residual income — with commission payments scheduled for the 10th of every month.',
  'referral.copy.alternate': 'As a partner of The Club, you can not only earn from your investments but also help others grow their income. Our 5-level compensation plan enables you to build long-term residual income — with commission payments scheduled for the 10th of every month.',
  'referral.table.level': 'Level',
  'referral.table.commission': 'Commission',
  'referral.table.levelNumber': 'Level {level}',
  'referral.structure.title': 'Tier Structure',
  'referral.commission.title': 'Compensation Plan - Create Your Passive Income!',
  'referral.commission.description.default': 'The compensation plan pays up to 20% (combined) on the first 10 levels of depth based on the profits generated by clients on a monthly basis. This gives each affiliate the opportunity to earn a real and growing monthly income thanks to the compound interest effect, which allows every affiliate to see their client portfolio grow over time, supported by the high performance of our trading strategies.',
  'referral.commission.description.alternate': 'The compensation plan pays up to 12% (combined) on the first 5 levels of depth based on the profits generated by clients on a monthly basis. This gives each affiliate the opportunity to earn a real and growing monthly income thanks to the compound interest effect, which allows every affiliate to see their client portfolio grow over time, supported by the high performance of our trading strategies.',
  'referral.example.title': 'Example Scenario',
  'referral.example.text': 'If you refer 3 people who each invest $1,000, and each of them refers 2 more people, you earn commissions from all 9 people in your community — creating a powerful passive income stream.',
  
  // New ReferralSection keys
  'referral.you': 'You',
  'referral.level1Commission': 'Level 1: 5% Commission',
  'referral.directReferral': 'Direct Referral',
  'referral.levels2to4Commission': 'Levels 2-4:  3% Commission',
  'referral.levels5to6Commission': 'Levels 5-6:  2% Commission Each',
  'referral.level7Commission': 'Level 7: 1%',
  'referral.level8Commission': 'Level 8: 0.5%',
  'referral.level9Commission': 'Level 9: 0.3%',
  'referral.level10Commission': 'Level 10: 0.2%',
  'referral.communityExpands': 'Your community expands deeper, earning you commissions up to {maxLevels} levels',
  'referral.earnCommissions.default': 'The compensation plan is based on a UNILEVEL structure that pays up to 10 levels deep. Our structure rewards you for building a strong community.',
  'referral.earnCommissions.alternate': 'The compensation plan is based on a UNILEVEL structure that pays up to 5 levels deep. Our structure rewards you for building a strong community.',
  'referral.levelSuffix': 'Level',
  
  // Events section
  'events.header': 'Events & Community',
  'events.subtitle': 'A Club that Connects',
  'events.text': 'Join webinars, meet other investors, and be part of something bigger. See what\'s happening — online and in person.',
  'events.event1': 'Events Coming Soon',
  'events.event2': 'Events Coming Soon',
  'events.event3': 'Events Coming Soon',
  'events.communityHighlights': 'Community Highlights',
  'events.weeklyStrategySessions': 'Weekly Strategy Sessions',
  'events.weeklyStrategySessionsDesc': 'Join our experts analyzing market opportunities',
  'events.investorInterviews': 'Investor Interviews',
  'events.investorInterviewsDesc': 'Hear success stories from our growing community',
  'events.educationalResources': 'Educational Resources',
  'events.tradingFundamentals': 'Trading Fundamentals',
  'events.tradingFundamentalsDesc': 'Free guides to understanding trading',
  'events.expertWebinars': 'Expert Webinars',
  'events.expertWebinarsDesc': 'Advanced topics for experienced users',
  
  // Connect section
  'connect.header': 'Stay Connected',
  'connect.subtitle': 'Let\'s Keep in Touch',
  'connect.whatsapp': 'Contact us via WhatsApp',
  'connect.language.english': 'English',
  'connect.language.italian': 'Italiano',
  'connect.language.spanish': 'Español',
  'connect.language.german': 'Deutsch',
  'connect.language.croatian': 'Hrvatski',
  'connect.language.turkish': 'Türkçe',
  'connect.language.french': 'Français',
  'connect.language.arabic': 'العربية',
  
  // Footer section
  'footer.rights': 'All rights reserved.',
  'footer.terms': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.cookies': 'Cookies',
  'footer.contactMe': 'Contact me',
  
  // Strategies page
  //'strategies.heroSubtitle': 'Two Strategies. One Vision. Maximum Protection & Growth.',
  'strategies.pageTitle': 'TheClub Strategies',
  'strategies.heroSubtitle': 'One Vision. Maximum Protection & Growth.',
  'strategies.learnMore': 'Learn More',
  'strategies.showLess': 'Show Less',

  // Institutional Strategy
  'strategies.institutional.tagline': 'Precision. Stability. Institutional-Grade Protection.',
  'strategies.institutional.highlight1': '16 Years Experience',
  'strategies.institutional.highlight1Desc': 'British institutional traders with hedge fund & Deutsche Bank background',
  'strategies.institutional.highlight2': 'Gold & GU Focus',
  'strategies.institutional.highlight2Desc': 'Medium/high frequency algorithms on Gold and Pound/Dollar',
  'strategies.institutional.highlight3': '5–6% Monthly Target',
  'strategies.institutional.highlight3Desc': 'Consistent returns averaging 35–40% annually',
  'strategies.institutional.highlight4': 'Controlled Risk',
  'strategies.institutional.highlight4Desc': 'Conservative approach prioritizing capital preservation',
  'strategies.institutional.description': 'It is a strategy managed directly by our British institutional traders, a working group that has been operating in financial markets for 16 years. They have worked with one of the most important hedge funds in the UK as well as with Deutsche Bank. They specialize in the creation and continuous updates of algorithms that operate at medium/high frequency mainly on Gold and GU (Pound/Dollar). It is a strategy that aims to obtain an average of 5–6% per month, as already achieved in the first year with The Club, while maintaining relatively contained risk in order to provide the client with an average of around 35–40% annually.',

  // Spartan AI Strategy
  'strategies.spartanAi.tagline': 'Aggressive. Intelligent. Spartan-Grade Performance.',
  'strategies.spartanAi.highlight1': 'AI-Powered',
  'strategies.spartanAi.highlight1Desc': 'Continuously updated artificial intelligence by Italian traders',
  'strategies.spartanAi.highlight2': 'Intraday Gold',
  'strategies.spartanAi.highlight2Desc': 'Semi-manual strategy combining AI operations with manual trades',
  'strategies.spartanAi.highlight3': 'Higher Profit Potential',
  'strategies.spartanAi.highlight3Desc': 'More aggressive approach generating superior returns',
  'strategies.spartanAi.highlight4': '20% Equity Stop',
  'strategies.spartanAi.highlight4Desc': 'Maximum loss protection covered by Institutional profits',
  'strategies.spartanAi.description': 'It is an artificial intelligence created and continuously updated by our group of Italian traders who have been working professionally in the trading world for 6 years now with excellent results. It is a more aggressive strategy that works in a semi-manual way: the traders themselves operate by combining the AI\'s operations with their own manual trades. It works intraday exclusively on Gold. It is a strategy that tends to generate much higher profits but at the same time has a 20% equity stop. This means that the client will never be able to lose more than 20% of the capital invested in Spartan; this capital is covered by the Institutional strategy with its profits in the event that, once a year, this equity stop is reached.',

  // Strategy Bond (50/50)
  'strategies.bond.title': 'Stronger Together: The 50/50 Approach',
  'strategies.bond.description': 'Every deposit is strategically divided 50/50 between both strategies. The Institutional Strategy provides a stable, conservative foundation that protects your capital, while Spartan AI delivers aggressive growth potential. In the rare event that Spartan AI reaches its 20% equity stop, the Institutional Strategy\'s consistent profits serve as a safety net — ensuring your overall investment remains protected and growing.',
  'strategies.bond.benefit1': 'Maximum Protection',
  'strategies.bond.benefit1Desc': 'Institutional profits safeguard against Spartan equity stops',
  'strategies.bond.benefit2': 'Smart Diversification',
  'strategies.bond.benefit2Desc': 'Two distinct approaches reduce overall portfolio risk',
  'strategies.bond.benefit3': 'Optimized Growth',
  'strategies.bond.benefit3Desc': 'Conservative stability meets aggressive profit potential',

  // Floating button
  'floatingButton.embassador.title': 'Become a The Club Ambassador',
  'floatingButton.embassador.text': 'Join our referral program and earn fantastic commissions while helping others achieve financial freedom. Contact us via WhatsApp to start your journey as a Club ambassador today!',
  'floatingButton.embassador.button': 'Become a The Club Ambassador',
  'floatingButton.embassador.contact': 'Connect With a Representative',
  'floatingButton.embassador.feature1': 'Build your community',
  'floatingButton.embassador.feature2': 'Earn up to {maxLevels} levels of commissions',
  'floatingButton.embassador.feature3': 'On-time payments, scheduled for the 15th of each month',
};

export default homepage;
